var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "480"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "rounded-0",
          attrs: {
            "color": "secondary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v("수정하기")])];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" 연락처 노출 여부 변경 "), _c('v-spacer'), _c('v-icon', {
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-card-text', {
    staticClass: "pa-6"
  }, [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-switch', {
    staticClass: "my-0",
    attrs: {
      "label": "검색 공개",
      "inset": "",
      "hide-details": ""
    },
    model: {
      value: _vm.inputs.isDisplayed,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "isDisplayed", $$v);
      },
      expression: "inputs.isDisplayed"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-switch', {
    staticClass: "my-0",
    attrs: {
      "label": "연락처 공개",
      "inset": "",
      "hide-details": ""
    },
    model: {
      value: _vm.inputs.isContactDisplayed,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "isContactDisplayed", $$v);
      },
      expression: "inputs.isContactDisplayed"
    }
  })], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "rounded-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("수정")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }